/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Utilities;
    (function (Utilities) {
        Utilities.PRIMARY_SLOT_KEY = '[[PRIMARY]]';
        Utilities.RELATED_SLOT_KEY = '[[RELATED]]';
        Utilities.WF_DRIVING_DOC_KEY = '[[WF_DRIVING_DOC]]';
        Utilities.WF_USER_VIEW_DOC_KEY = '[[WF_USER_VIEW_DOC]]';
        Utilities.RELATED_UPLOAD_SLOT_KEY = '[[RELATED_UPLOAD_MASTER]]';
        Utilities.BLOCKED_VALUE = "[%%[BLOCKED_BY_WPT_INHERITANCE_RULES]%%]"; // this value is used in the Service Layer for document and WorkView object queries as well
        const QUERYSTRING_FILTERITEM = "filterby";
        const LOG_CATEGORY = "WPT.Context";
        class ApplicationContext {
            // Main methods
            constructor(core) {
                this._log = null;
                // All the object entities we need to store
                this._docRegistry = {};
                this._wvObjectRegistry = {};
                // Prefills and search macros
                this._archivePrefillKeys = []; // List of sessionVariables which should be pulled as prefills for archive
                this._sessionVariables = {}; // All sessionVariables. key /might/ be keyword, but can be any tag
                this._prefillMap = [];
                this._queryStringOverrides = true;
                this.init = () => {
                    this._log.info("ApplicationContext.init()");
                    // Clear everything down
                    this._docRegistry = {};
                    this._wvObjectRegistry = {};
                    this._archivePrefillKeys = [];
                    this._sessionVariables = {};
                    let appConfig = this._core.Config.getApplicationConfig();
                    // Query string prefill map
                    if (appConfig.hasOwnProperty('QueryStringHandling') && (appConfig.QueryStringHandling != null)) {
                        if (appConfig.QueryStringHandling.hasOwnProperty('PrefillQueryStringMap') && (appConfig.QueryStringHandling.PrefillQueryStringMap != null)) {
                            this._prefillMap = appConfig.QueryStringHandling.PrefillQueryStringMap;
                        }
                        if (appConfig.QueryStringHandling.hasOwnProperty('QueryStringOverridesUserPrefills') && (appConfig.QueryStringHandling.QueryStringOverridesUserPrefills != null)) {
                            this._queryStringOverrides = appConfig.QueryStringHandling.QueryStringOverridesUserPrefills;
                        }
                    }
                    // Get the configured session variables first
                    this._populateSessionVariablesFromConfig();
                    // Grab query string filter items, order by index
                    // I *hate* that this is a string array pretending to be a dictionary, but here we are
                    this._log.trace('Processing query string values');
                    let queryValues = this._core.QueryStringValues;
                    for (let key in queryValues) {
                        if (key.startsWith(QUERYSTRING_FILTERITEM)) {
                            let tag = key.substring(QUERYSTRING_FILTERITEM.length);
                            let value = queryValues[key];
                            // Add as raw entry
                            this.setSessionVariable(tag, value, false, this._queryStringOverrides);
                            // Check if we're a prefill as well, in which case tag as keyword name
                            if (this._prefillMap.length > 0) {
                                let mapEntry = this._prefillMap.find(m => m.QueryTag == tag);
                                if (mapEntry)
                                    this.setSessionVariable(mapEntry.Keyword, value, true, this._queryStringOverrides);
                            }
                        }
                    }
                };
                // Session Variable population in a function
                this._populateSessionVariablesFromConfig = () => {
                    this._log.info("ApplicationContext._populateSessionVariablesFromConfig()");
                    // Populate in order, with overwriting: gateway global, gateway application record, application config
                    let gwConfig = this._core.Config.getMainConfig();
                    if (gwConfig && gwConfig.hasOwnProperty('SessionVariables') && (gwConfig.SessionVariables != null)) {
                        gwConfig.SessionVariables.forEach(sv => {
                            let prefill = (sv.hasOwnProperty('ArchivePrefill') && (sv.ArchivePrefill != null)) ? sv.ArchivePrefill : false;
                            this.setSessionVariable(sv.Key, sv.Value, prefill, true);
                        });
                    }
                    let gwAppRecord = this._core.Config.getSelectedApplication();
                    if (gwAppRecord && gwConfig.hasOwnProperty('SessionVariables') && (gwAppRecord.SessionVariables != null)) {
                        gwAppRecord.SessionVariables.forEach(sv => {
                            let prefill = (sv.hasOwnProperty('ArchivePrefill') && (sv.ArchivePrefill != null)) ? sv.ArchivePrefill : false;
                            this.setSessionVariable(sv.Key, sv.Value, prefill, true);
                        });
                    }
                    let mainAppConfig = this._core.Config.getApplicationConfig();
                    if (mainAppConfig && mainAppConfig.hasOwnProperty('SessionVariables') && (mainAppConfig.SessionVariables != null)) {
                        mainAppConfig.SessionVariables.forEach(sv => {
                            let prefill = (sv.hasOwnProperty('ArchivePrefill') && (sv.ArchivePrefill != null)) ? sv.ArchivePrefill : false;
                            this.setSessionVariable(sv.Key, sv.Value, prefill, true);
                        });
                    }
                };
                this.documentSlotPopulated = (slot) => {
                    this._log.info("ApplicationContext.documentSlotPopulated()");
                    if ((slot in this._docRegistry) && (this._docRegistry[slot] != null))
                        return true;
                    else
                        return false;
                };
                this.getDocumentFromSlot = (slot) => {
                    this._log.info("ApplicationContext.getDocumentFromSlot()");
                    if (slot in this._docRegistry)
                        return this._docRegistry[slot];
                    else
                        return null;
                };
                this.deleteDocumentFromSlot = (slot) => {
                    this._log.info("ApplicationContext.deleteDocumentFromSlot()");
                    if (slot in this._docRegistry)
                        delete this._docRegistry[slot];
                };
                this.pushDocumentToSlots = (doc, slots, callback = null, preserve = false) => {
                    this._log.info("ApplicationContext.pushDocumentToSlot()");
                    let tempSlots = [];
                    tempSlots.push(...slots);
                    let activeSlots = [];
                    while (tempSlots.length > 0) {
                        let slot = tempSlots.shift();
                        if (!((slot in this._docRegistry) && preserve) && (activeSlots.indexOf(slot) == -1))
                            activeSlots.push(slot);
                    }
                    // If nothing to do, call back and exit
                    if (activeSlots.length == 0) {
                        this._log.trace("No active slots remain in slot list, returning");
                        if (callback)
                            callback();
                        return;
                    }
                    // Temporarily (maybe) populate slots with document
                    activeSlots.forEach(slot => {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Inserting doc into slot '${slot}' (first run)`);
                        }
                        this._docRegistry[slot] = doc;
                    });
                    // Now, we might not have keywords but we're going to need them before handing control back, so...
                    if (!doc.hasOwnProperty('KeywordsPopulated') || !doc.KeywordsPopulated) {
                        // We need the document keywords before proceeding
                        this._log.trace('Doc has no keywords, requesting population');
                        this._core.OBHelper.GetDocumentMetadata(doc.ItemNum, this._documentMetadataReceived.bind(this, activeSlots, callback), this._cacheCallErrorHandler.bind(this, activeSlots, callback), this._cacheCallFailedHandler.bind(this, activeSlots, callback));
                    }
                    else if (callback)
                        callback();
                };
                // We might get activated with a document ID and no actual document...
                // TODO: I really don't like this possible hole but will have to do short term. Suspect we should ALWAYS activate with a doc object if possible
                this.pushDocumentToSlotsById = (docId, slots, callback = null, preserve = false) => {
                    let doc = {
                        ItemNum: docId,
                        Name: "",
                        FileType: "",
                        DocType: null
                    };
                    this.pushDocumentToSlots(doc, slots, callback, preserve);
                };
                this._documentMetadataReceived = (slots, callback, doc) => {
                    // Update with full metadata
                    this._log.trace('Doc keyword population returned');
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Inserting doc into ${slots.length} slots (second run)`);
                    }
                    slots.forEach(slot => {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Inserting doc into slot '${slot}' (second run)`);
                        }
                        this._docRegistry[slot] = doc;
                    });
                    // Now hand back control
                    if (callback)
                        callback();
                };
                this._cacheCallFailedHandler = (slots, callback, json) => {
                    this._log.info("ApplicationContext._cacheCallFailedHandler()");
                    let response = json;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CONFIG_CACHE", "STR_WPT_ERROR", response.Connection.Message);
                    if (callback)
                        callback();
                };
                this._cacheCallErrorHandler = (slots, callback, url, status, message) => {
                    this._log.info("ApplicationContext._cacheCallErrorHandler()");
                    let msg = `${status}: ${message} - [${url}]`;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CONFIG_CACHE", "STR_WPT_ERROR", message);
                    if (callback)
                        callback();
                };
                this.popDocumentFromSlot = (slot) => {
                    this._log.info("ApplicationContext.popDocumentFromSlot()");
                    let doc = null;
                    if (slot in this._docRegistry) {
                        doc = this._docRegistry[slot];
                        delete this._docRegistry[slot];
                    }
                    return doc;
                };
                this._pushWvObjectToSlotsByRequest = (objectRequst, slots, callback = null, preserve = false) => {
                    this._log.info("ApplicationContext._pushWvObjectToSlotsByRequest()");
                    let tempSlots = [];
                    tempSlots.push(...slots);
                    let activeSlots = [];
                    while (tempSlots.length > 0) {
                        let slot = tempSlots.shift();
                        if (!((slot in this._wvObjectRegistry) && preserve) && (activeSlots.indexOf(slot) == -1))
                            activeSlots.push(slot);
                    }
                    // If nothing to do, call back and exit
                    if (activeSlots.length == 0) {
                        this._log.trace("No active slots remain in slot list, returning");
                        if (callback)
                            callback();
                        return;
                    }
                    let request = JSON.stringify(objectRequst);
                    this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/GetObject', request, this._wvObjectReceived.bind(this, activeSlots, callback), null, this._cacheCallErrorHandler.bind(this, activeSlots, callback), this._cacheCallFailedHandler.bind(this, activeSlots, callback));
                };
                this._wvObjectReceived = (slots, callback, wvObject) => {
                    this._log.info("ApplicationContext._wvObjectReceived()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Inserting WV Object into ${slots.length} slots`);
                    }
                    slots.forEach(slot => {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Inserting WV Object into slot '${slot}'`);
                        }
                        this._wvObjectRegistry[slot] = wvObject.Object;
                    });
                    // Now hand back control
                    if (callback)
                        callback();
                };
                this._isRequestedWvObject = (wvObject, request) => {
                    this._log.info("ApplicationContext._isRequestedWvObject()");
                    if (wvObject.Class.Application.Name == request.Application && wvObject.Class.Name == request.Class && wvObject.Id == request.ObjectId) {
                        this._log.trace("is requested object");
                        return true;
                    }
                    return false;
                };
                this._deleteWvObjectFromSlot = (slot) => {
                    this._log.info("ApplicationContext._deleteWvObjectFromSlot()");
                    if (slot in this._wvObjectRegistry)
                        delete this._wvObjectRegistry[slot];
                };
                this.wvObjectSlotPopulated = (slot) => {
                    this._log.info("ApplicationContext.wvObjectSlotPopulated()");
                    if ((slot in this._wvObjectRegistry) && (this._wvObjectRegistry[slot] != null))
                        return true;
                    else
                        return false;
                };
                this.getWvObjectFromSlot = (slot) => {
                    this._log.info("ApplicationContext.getWvObjectFromSlot()");
                    if (slot in this._wvObjectRegistry)
                        return this._wvObjectRegistry[slot];
                    else
                        return null;
                };
                // Sets session variables from whatever source
                this.setSessionVariable = (key, value, isArchivePrefill = false, replaceExisting = true) => {
                    this._log.info("ApplicationContext.setSessionVariable()");
                    let prefillIndex = this._archivePrefillKeys.indexOf(key);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Setting ${key} = ${value} with prefill = ${isArchivePrefill}`);
                    }
                    if (value) {
                        if ((Object.keys(this._sessionVariables).indexOf(key) == -1) || replaceExisting) {
                            this._sessionVariables[key] = value;
                        }
                        if (isArchivePrefill && (prefillIndex == -1))
                            this._archivePrefillKeys.push(key);
                        // If resetting and NOT prefill, want to remove from array
                        if (!isArchivePrefill && (prefillIndex > -1))
                            this._archivePrefillKeys.splice(prefillIndex, 1);
                    }
                    else {
                        if (Object.keys(this._sessionVariables).indexOf(key) > -1)
                            delete this._sessionVariables[key];
                        if (prefillIndex > -1)
                            this._archivePrefillKeys.splice(prefillIndex, 1);
                    }
                };
                // Applies all macros in the current string, ONLY TAKES SINGLE/FIRST INSTANCES
                this.applyAllMacros = (source) => {
                    this._log.info("ApplicationContext.applyAllMacros()");
                    let re = /{(.*?)}/g;
                    let matches = source.match(re);
                    let workingCopy = source;
                    if (matches) {
                        matches.forEach(m => {
                            let hits = this.expandMacro(m.substring(1, m.length - 1));
                            if (hits.length > 0)
                                workingCopy = workingCopy.replace(m, hits[0]);
                        });
                    }
                    return workingCopy;
                };
                // Expand filter macro to zero or more strings depending on request context
                this.expandMacro = (source) => {
                    if (this._log.isTraceEnabled) {
                        this._log.trace(`ApplicationContext.expandMacro("${source})"`);
                    }
                    else
                        this._log.info("ApplicationContext.expandMacro()");
                    let result = [];
                    if (!source)
                        return result;
                    // Special treatment if user configures multiple macros into one string
                    if (source.startsWith('[[MULTIMACRO]]')) {
                        result.push(this.applyAllMacros(source.slice(14)));
                        return result;
                    }
                    // Massage the tags to cope with old ones but only process new ones - ORDER OF THESE REPLACEMENTS IS IMPORTANT!
                    let fixedSrc = source;
                    if (fixedSrc.startsWith('[[PRIMARY]]'))
                        fixedSrc = fixedSrc.replace('[[PRIMARY]]', `[[DOC_SLOT:${Utilities.PRIMARY_SLOT_KEY}]]`);
                    if (fixedSrc.startsWith('[[RELATED]]'))
                        fixedSrc = fixedSrc.replace('[[RELATED]]', `[[DOC_SLOT:${Utilities.RELATED_SLOT_KEY}]]`);
                    fixedSrc = fixedSrc.replace('[[QUERY_STRING_FILTER', '[[SESSION_VAR');
                    fixedSrc = fixedSrc.replace('[[DOCUMENT_SLOT', '[[DOC_SLOT');
                    fixedSrc = fixedSrc.replace('[[INHERIT]]', `[[DOC_SLOT:${Utilities.PRIMARY_SLOT_KEY}]]`);
                    fixedSrc = fixedSrc.replace('[[INHERIT_BLOCK_NULLS]]', `[[DOC_SLOT_BLOCK_NULLS:${Utilities.PRIMARY_SLOT_KEY}]]`);
                    // Optional translation support - NB, plain text macro content is ALWAYS translated
                    let translateResults = false;
                    if (fixedSrc.startsWith('[[TRANSLATE:')) {
                        fixedSrc.replace('[[TRANSLATE:', '[[');
                        translateResults = true;
                    }
                    if (this._log.isTraceEnabled) {
                        this._log.trace(`ApplicationContext.expandMacro fixed source = "${fixedSrc}"`);
                    }
                    // Check for all the special cases, otherwise just return the values we received
                    // Session variables
                    if (fixedSrc.startsWith('[[SESSION_VAR]]') || fixedSrc.startsWith('[[SESSION_VAR_BLOCK_NULLS]]')) {
                        if (this._log.isTraceEnabled())
                            this._log.trace(`populating from session vars '${fixedSrc}'`);
                        let chunks = fixedSrc.split(':');
                        if (chunks.length == 2) {
                            if (Object.keys(this._sessionVariables).indexOf(chunks[1]) != -1) {
                                let value = (translateResults) ? this._core.Locale.getTranslation(this._sessionVariables[chunks[1]]) : this._sessionVariables[chunks[1]];
                                result.push(value);
                            }
                            else if (fixedSrc.startsWith('[[SESSION_VAR_BLOCK_NULLS]]'))
                                result.push(Utilities.BLOCKED_VALUE);
                        }
                    }
                    else if (fixedSrc.startsWith('[[DOC_SLOT:') || fixedSrc.startsWith('[[DOC_SLOT_BLOCK_NULLS:')) {
                        // This splits to '[[DOC_SLOT', '<slotname>]]', '<keyword name>'
                        let chunks = fixedSrc.split(':');
                        if (this._log.isTraceEnabled())
                            this._log.trace(`populating from document keys '${chunks}'`);
                        if (chunks.length == 3) {
                            let slot = chunks[1].slice(0, -2);
                            if (this._core.Context.documentSlotPopulated(slot)) {
                                let inheritValues = this._core.OBHelper.GetAllKeywordValues(this.getDocumentFromSlot(slot), chunks[2]);
                                if (inheritValues.length > 0) {
                                    inheritValues.forEach(value => {
                                        if (translateResults)
                                            result.push(this._core.Locale.getTranslation(value));
                                        else
                                            result.push(value);
                                    });
                                }
                                else if (fixedSrc.startsWith('[[DOC_SLOT_BLOCK_NULLS:'))
                                    result.push(Utilities.BLOCKED_VALUE);
                            }
                            else if (fixedSrc.startsWith('[[DOC_SLOT_BLOCK_NULLS:'))
                                result.push(Utilities.BLOCKED_VALUE);
                        }
                    }
                    else if (fixedSrc.startsWith('[[WVOBJ_SLOT:') || fixedSrc.startsWith('[[WVOBJ_SLOT_BLOCK_NULLS:')) {
                        // This splits to '[[DOCUMENT_SLOT', '<slotname>]]', '<keyword name>'
                        let chunks = fixedSrc.split(':');
                        if (chunks.length == 3) {
                            let slot = chunks[1].slice(0, -2);
                            if (this._core.Context.wvObjectSlotPopulated(slot)) {
                                let inheritValue = this._core.OBHelper.GetObjectAttributeValue(this.getWvObjectFromSlot(slot), chunks[2]);
                                if (inheritValue) {
                                    if (translateResults)
                                        result.push(this._core.Locale.getTranslation(inheritValue));
                                    else
                                        result.push(inheritValue);
                                }
                                else if (fixedSrc.startsWith('[[WVOBJ_SLOT_BLOCK_NULLS:'))
                                    result.push(Utilities.BLOCKED_VALUE);
                            }
                            else if (fixedSrc.startsWith('[[WVOBJ_SLOT_BLOCK_NULLS:'))
                                result.push(Utilities.BLOCKED_VALUE);
                        }
                    }
                    else if (fixedSrc == '[[CURRENT_USER_NAME]]') {
                        result.push(this._core.getCurrentUsername());
                    }
                    else if (fixedSrc == '[[CURRENT_LOCALE_CODE]]') {
                        result.push(this._core.Locale.getSelectedLocale().LocaleCode);
                    }
                    else if (fixedSrc.startsWith('[[DATEMACRO]]')) {
                        result.push(this._expandDateMacro(fixedSrc));
                    }
                    else
                        result.push(this._core.Locale.getTranslation(source));
                    return result;
                };
                this._expandDateMacro = (source) => {
                    this._log.info("ApplicationContext._expandDateMacro()");
                    let chunks = source.split(':');
                    if (chunks.length < 2)
                        return '';
                    // Lop out our macro declaration and grab the start point
                    chunks.shift();
                    let workingDate = this._interpretDateStartPoint(chunks.shift());
                    // At this point, we may still have operations to perform on the date
                    while (chunks.length > 0) {
                        workingDate = this._applyDateOperation(workingDate, chunks.shift());
                    }
                    return this._core.Functions.dateToTransportFormat(workingDate);
                };
                this._interpretDateStartPoint = (source) => {
                    this._log.info("ApplicationContext._interpretDateStartPoint()");
                    // Default is now
                    let output = new Date();
                    if (source.startsWith('PREVIOUS_')) {
                        // Only a problem if we are exactly on a target date
                        source = source.replace('PREVIOUS_', 'MOSTRECENT_');
                        // Want to set to yesterday - this is imperfect when daylight saving cuts in but that's such an edge case I'm ignoring it
                        output = new Date(Date.now() - 86400000);
                    }
                    if (source == 'FIRST_OF_MONTH') {
                        output = new Date(output.getFullYear(), output.getMonth(), 1);
                    }
                    else if (source == 'FIRST_OF_YEAR') {
                        // Months count from zero, days from 1. Good work, Javascript designers!
                        output = new Date(output.getFullYear(), 0, 1);
                    }
                    else if (source.startsWith('MOSTRECENT_')) {
                        let chunks = source.split('_');
                        if (chunks.length > 1) {
                            let requestedDay = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].indexOf(chunks[1].toLowerCase());
                            if (requestedDay > -1) {
                                let diff = (7 + (output.getDay() - requestedDay)) % 7;
                                output.setDate(output.getDate() - diff);
                            }
                            else {
                                // If we get here, we should have MMM-dd
                                // NOTE: Doesn't handle FEB29th well. If you really want last day in Feb, use JAN-31:+1M
                                let dateChunks = chunks[1].split('-');
                                let requestedMonth = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'].indexOf(dateChunks[0].toLowerCase());
                                let requestedDay = Number(dateChunks[1]);
                                if ((requestedMonth > -1) && (!isNaN(requestedDay))) {
                                    if (requestedMonth > output.getMonth())
                                        output.setFullYear(output.getFullYear() - 1);
                                    else if ((requestedMonth == output.getMonth()) && (requestedDay > output.getDate()))
                                        output.setFullYear(output.getFullYear() - 1);
                                    output.setMonth(requestedMonth);
                                    output.setDate(requestedDay);
                                }
                            }
                        }
                    }
                    // Date, not time!
                    output.setHours(0);
                    output.setMinutes(0);
                    output.setSeconds(0);
                    output.setMilliseconds(0);
                    return output;
                };
                this._applyDateOperation = (workingDate, opString) => {
                    this._log.info("ApplicationContext._applyDateOperation()");
                    // Date operation is pretty simple, must be in non-spaced format:
                    // + or -, integer, time unit ("y", "M", "d")
                    // e.g. +7d, -1y, +30d etc. Will do basic checking, and do nothing if the format is off.
                    if (!opString || (opString.length < 3))
                        return workingDate;
                    let num = Number(opString.slice(0, -1));
                    let unit = opString.slice(-1);
                    if (isNaN(num) || !unit)
                        return workingDate;
                    // Superficially safe here - if the unit isn't valid we just return with no changes
                    if (unit == 'd') {
                        // Apparently there is some weirdness with day arithmetic if you don't use some indirection here. Unclear why.
                        let tempDate = new Date(workingDate);
                        tempDate.setDate(tempDate.getDate() + num);
                        workingDate = tempDate;
                    }
                    else if (unit == 'M') {
                        let day = workingDate.getDate();
                        workingDate.setMonth(workingDate.getMonth() + num);
                        // This sets the date back to the last day of the previous month - if the day-of-month has changed, we must have overrun
                        if (day != workingDate.getDate())
                            workingDate.setDate(0);
                    }
                    else if (unit == 'Y') {
                        workingDate.setFullYear(workingDate.getFullYear() + num);
                    }
                    return workingDate;
                };
                this.getArchivePrefillValue = (key) => {
                    this._log.info("ApplicationContext.getArchivePrefillValue()");
                    if (this._archivePrefillKeys.indexOf(key) == -1)
                        return null;
                    if (Object.keys(this._sessionVariables).indexOf(key) == -1)
                        return null;
                    return this.applyAllMacros(this._sessionVariables[key]);
                };
                this.evaluateSelectionCriteria = (conditions, doc = null, obj = null, context = null) => {
                    this._log.info("ApplicationContext.evaluateSelectionCriteria()");
                    for (let i = 0; i < conditions.length; i++) {
                        if (!this.evaluateSelectionCriterion(conditions[i], doc, obj, context))
                            return false;
                    }
                    return true;
                };
                this.evaluateSelectionCriterion = (condition, doc = null, obj = null, context = null) => {
                    var _a, _b;
                    this._log.info("ApplicationContext.evaluateSelectionCriterion()");
                    // First we need to figure out our target
                    let targetName = (condition.hasOwnProperty('EvaluateAgainst') && condition.EvaluateAgainst) ? condition.EvaluateAgainst : '[[DOC_SLOT:[[SUPPLIED]]]]';
                    let target = this._selectEvalTarget(targetName, doc, obj, context);
                    // Then we need to figure out our value
                    let conditionValue = this.expandMacro(condition.Value)[0];
                    // And we need to figure out our operator
                    let operator = (condition.hasOwnProperty('Operator') && condition.Operator) ? condition.Operator : "Equal";
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`checking on ${condition.Type} '${operator}' '${conditionValue}'`);
                    }
                    switch (condition.Type) {
                        case 'Always':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace('condition type is Always, returning true');
                            }
                            return true;
                        case 'ActivationType':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace('checking ActivationType');
                            }
                            if (target.Context) {
                                if (operator == "Equal" && conditionValue == target.Context.ActivationType)
                                    return true;
                                if (operator == "NotEqual" && conditionValue != target.Context.ActivationType)
                                    return true;
                            }
                            break;
                        case 'SessionVar':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`checking SessionVar '${condition.Source}'`);
                            }
                            let sessionValue = this._sessionVariables[condition.Source];
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`checking with SessionVar value '${sessionValue}'`);
                            }
                            if (operator == 'IsNotNull' && (sessionValue != null && sessionValue != undefined))
                                return true;
                            if (operator == 'IsNull' && (sessionValue == null || sessionValue == undefined))
                                return true;
                            if (operator == "Equal" && conditionValue == sessionValue)
                                return true;
                            if (operator == "NotEqual" && conditionValue != sessionValue)
                                return true;
                            break;
                        case 'DocType':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace('checking DocType');
                            }
                            if (target.Doc) {
                                if (operator == "Equal" && conditionValue == target.Doc.DocType.Name)
                                    return true;
                                if (operator == "NotEqual" && conditionValue != target.Doc.DocType.Name)
                                    return true;
                            }
                            break;
                        case 'FileType':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace('checking FileType');
                            }
                            if (target.Doc) {
                                if (operator == "Equal" && conditionValue == target.Doc.FileType)
                                    return true;
                                if (operator == "NotEqual" && conditionValue != target.Doc.FileType)
                                    return true;
                            }
                            break;
                        case 'Keyword':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`checking on keyword '${condition.Source}'`);
                            }
                            // backwards compability for [[ANY_VALUE]], move to new operator
                            // Hyphen in initial release (used in BMW) but underscore consistent with other [[]] tags. Matt's fault.
                            if (((conditionValue == '[[ANY-VALUE]]') || (conditionValue == '[[ANY_VALUE]]')) && operator == "Equal")
                                operator = "IsNotNull";
                            if (target.Doc) {
                                // Need to check all keys of the given type
                                let keyValues = this._core.OBHelper.GetAllKeywordValues(target.Doc, condition.Source);
                                if (keyValues == null || keyValues == undefined)
                                    keyValues = [];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`checking with keyword values '${keyValues}'`);
                                }
                                if (operator == 'IsNotNull' && keyValues.length > 0)
                                    return true;
                                if (operator == 'IsNull' && keyValues.length == 0)
                                    return true;
                                if (operator == 'Equal' && keyValues.indexOf(conditionValue) > -1)
                                    return true;
                                if (operator == 'NotEqual' && keyValues.indexOf(conditionValue) == -1)
                                    return true;
                            }
                            break;
                        case 'WvClass':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace('checking WvClass');
                            }
                            if (target.Obj) {
                                if (operator == "Equal" && conditionValue == ((_a = target.Obj.Class) === null || _a === void 0 ? void 0 : _a.Name))
                                    return true;
                                if (operator == "NotEqual" && conditionValue != ((_b = target.Obj.Class) === null || _b === void 0 ? void 0 : _b.Name))
                                    return true;
                            }
                            break;
                        case 'Attribute':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`checking on attribute '${condition.Source}'`);
                            }
                            if (target.Obj) {
                                let attrValue = this._core.OBHelper.GetObjectAttributeValue(target.Obj, condition.Source);
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`checking with attribute value '${attrValue}'`);
                                }
                                if (operator == 'IsNotNull' && (attrValue != null && attrValue != undefined))
                                    return true;
                                if (operator == 'IsNull' && (attrValue == null || attrValue == undefined))
                                    return true;
                                if (operator == 'Equal' && conditionValue == attrValue)
                                    return true;
                                if (operator == 'NotEqual' && conditionValue != attrValue)
                                    return true;
                            }
                            break;
                    }
                    // If we get here we have an unmatched criterion or an unknown condition type (or possibly a trigger)
                    if (this._log.isTraceEnabled()) {
                        this._log.trace('returning FALSE');
                    }
                    return false;
                };
                this._selectEvalTarget = (targetName, doc = null, obj = null, context = null) => {
                    this._log.info("ApplicationContext._selectEvalTarget()");
                    let target = { Doc: null, Obj: null, Context: null };
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`looking at target name '${targetName}'`);
                    }
                    if (targetName == "Activation") {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace('adding activation context as target');
                        }
                        target.Context = context;
                    }
                    else if (targetName.startsWith('[[DOC_SLOT:')) {
                        let chunks = targetName.split(':');
                        if (chunks.length == 2) {
                            let slot = chunks[1].slice(0, -2);
                            if (slot == "[[SUPPLIED]]") {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace('adding supplied document as target');
                                }
                                target.Doc = doc;
                            }
                            else if (this.documentSlotPopulated(slot)) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`adding document from slot '${slot}' as target`);
                                }
                                target.Doc = this.getDocumentFromSlot(slot);
                            }
                        }
                    }
                    else if (targetName.startsWith('[[WVOBJ_SLOT:')) {
                        let chunks = targetName.split(':');
                        if (chunks.length == 2) {
                            let slot = chunks[1].slice(0, -2);
                            if (slot == "[[SUPPLIED]]") {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace('adding supplied WV object as target');
                                }
                                target.Obj = obj;
                            }
                            else if (this.wvObjectSlotPopulated(slot)) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`adding WV object from slot '${slot}' as target`);
                                }
                                target.Obj = this.getWvObjectFromSlot(slot);
                            }
                        }
                    }
                    return target;
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ApplicationContext::constructor");
                this.init();
            }
            // Accessor methods
            get PrimaryDocument() {
                this._log.info("ApplicationContext.PrimaryDocument() (getter)");
                if (Utilities.PRIMARY_SLOT_KEY in this._docRegistry)
                    return this._docRegistry[Utilities.PRIMARY_SLOT_KEY];
                else
                    return null;
            }
            get RelatedDocument() {
                this._log.info("ApplicationContext.RelatedDocument()");
                if (Utilities.RELATED_SLOT_KEY in this._docRegistry)
                    return this._docRegistry[Utilities.RELATED_SLOT_KEY];
                else
                    return null;
            }
            // We act as a message sink, and stash appropriate objects
            processActivation(context, callback = null) {
                this._log.info("ApplicationContext.processActivation()");
                if (context) {
                    let slots = [];
                    switch (context.ActivationType) {
                        case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                            // Safety net
                            if (context.Slots.length == 0)
                                context.Slots.push(Utilities.PRIMARY_SLOT_KEY);
                            if (context.hasOwnProperty('PrimaryContext') && (context.PrimaryContext != null))
                                this.pushDocumentToSlots(context.PrimaryContext, context.Slots, callback);
                            else
                                this.pushDocumentToSlotsById(context.ActivationID, context.Slots, callback);
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.RELATED_UPLOAD_REQUEST:
                            if (context.Slots.length > 0)
                                slots.push(...context.Slots);
                            slots.push(Utilities.RELATED_UPLOAD_SLOT_KEY);
                            if (context.hasOwnProperty('PrimaryContext') && (context.PrimaryContext != null))
                                this.pushDocumentToSlots(context.PrimaryContext, slots, callback);
                            else
                                this.pushDocumentToSlotsById(context.ActivationID, context.Slots, callback);
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                            context.Slots.forEach(slot => this.deleteDocumentFromSlot(slot));
                            if (callback)
                                callback();
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DELETED:
                            for (let slot in this._docRegistry) {
                                if ((this._docRegistry[slot] != null) && (this._docRegistry[slot].ItemNum == context.ActivationID))
                                    slots.push(slot);
                            }
                            slots.forEach(slot => {
                                this.deleteDocumentFromSlot(slot);
                            });
                            if (callback)
                                callback();
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_KEYWORDS_UPDATED:
                            // Keyword update requires we overwrite our slots
                            for (let slot in this._docRegistry) {
                                if ((this._docRegistry[slot] != null) && (this._docRegistry[slot].ItemNum == context.ActivationID))
                                    slots.push(slot);
                            }
                            if (slots.length > 0) {
                                if (context.hasOwnProperty('PrimaryContext') && (context.PrimaryContext != null))
                                    this.pushDocumentToSlots(context.PrimaryContext, slots, callback);
                                else
                                    this.pushDocumentToSlotsById(context.ActivationID, slots, callback);
                            }
                            else if (callback)
                                callback();
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_SELECTED:
                            // Safety net
                            if (context.Slots.length == 0)
                                context.Slots.push(Utilities.PRIMARY_SLOT_KEY);
                            this._pushWvObjectToSlotsByRequest(context.PrimaryContext, context.Slots, callback);
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_DESELECTED:
                            context.Slots.forEach(slot => this._deleteWvObjectFromSlot(slot));
                            if (callback)
                                callback();
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_UPDATED:
                            for (let slot in this._wvObjectRegistry) {
                                if ((this._wvObjectRegistry[slot] != null) && (this._isRequestedWvObject(this._wvObjectRegistry[slot], context.PrimaryContext)))
                                    slots.push(slot);
                            }
                            if (slots.length > 0) {
                                this._pushWvObjectToSlotsByRequest(context.PrimaryContext, slots, callback);
                            }
                            else {
                                if (callback)
                                    callback();
                            }
                            break;
                        case WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_DELETED:
                            for (let slot in this._wvObjectRegistry) {
                                if ((this._wvObjectRegistry[slot] != null) && (this._isRequestedWvObject(this._wvObjectRegistry[slot], context.PrimaryContext)))
                                    slots.push(slot);
                            }
                            slots.forEach(slot => {
                                this._deleteWvObjectFromSlot(slot);
                            });
                            if (callback)
                                callback();
                            break;
                        default:
                            if (callback)
                                callback();
                            break;
                    }
                }
                else {
                    // Don't think we should ever get here, but if we do we need to call back into the main activation chain
                    if (callback)
                        callback();
                }
            }
            // =================================================================  Support for consolidated macro processing
            get ArchivePrefillKeys() {
                return this._archivePrefillKeys;
            }
            get ArchivePrefillValues() {
                this._log.info("WPTCore.ArchivePrefillValues() (getter)");
                let prefills = [];
                this._archivePrefillKeys.forEach(tag => {
                    if (Object.keys(this._sessionVariables).indexOf(tag) > -1)
                        prefills.push({ Key: tag, Value: this.applyAllMacros(this._sessionVariables[tag]) });
                });
                return prefills;
            }
            get SessionVariables() {
                return this._sessionVariables;
            }
        }
        Utilities.ApplicationContext = ApplicationContext;
    })(Utilities = WPTNamespace.Utilities || (WPTNamespace.Utilities = {}));
})(WPTNamespace || (WPTNamespace = {}));
